import React from 'react';
import { Button } from 'react-bootstrap';

const MultistepFormsFooter = ({
  loading,
  values,
  handleSubmit,
  disabledSaveAndExit,
  onCancel,
  onBack,
  finalStep,
}) => {
  return (
    <div className="flex flex-justify">
      <div className="flex">
        <Button
          type="button"
          disabled={!onBack}
          className="btn btn-outlined flex"
          onClick={onBack}
        >
          <span style={{ fontSize: '20px', lineHeight: '16px' }}>←</span>
          &nbsp; Back
        </Button>

        {finalStep ? (
          <Button
            disabled={loading}
            bsStyle="primary"
            type="button"
            className="m-l-12"
            onClick={() => {
              values.finish = true;
              handleSubmit();
            }}
          >
            {loading ? 'Saving...' : 'Save'}
          </Button>
        ) : (
          <Button
            disabled={loading}
            bsStyle="primary"
            type="button"
            className="m-l-12"
            onClick={() => {
              values.finish = false;
              handleSubmit();
            }}
          >
            {loading ? 'Saving...' : 'Next'}
            &nbsp;
            <span style={{ fontSize: '20px', lineHeight: '16px' }}>→</span>
          </Button>
        )}

        {!disabledSaveAndExit && !finalStep ? (
          <button
            disabled={loading}
            type="button"
            className="btn-clear btn-link m-l-12"
            onClick={() => {
              values.finish = true;
              handleSubmit();
            }}
          >
            Save and Exit
          </button>
        ) : null}
      </div>
      <Button
        type="button"
        disabled={loading}
        className="btn btn-default"
        onClick={onCancel}
      >
        Cancel
      </Button>
    </div>
  );
};

export default MultistepFormsFooter;
